import { render, staticRenderFns } from "./TkLeftArrowButton.vue?vue&type=template&id=5291d932&"
import script from "./TkLeftArrowButton.vue?vue&type=script&lang=js&"
export * from "./TkLeftArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./TkLeftArrowButton.vue?vue&type=style&index=0&id=5291d932&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports